module.exports = __webpack_public_path__ + "img/d4ce40e.svg";